import { EmptyDownload } from '~modules/downloads/EmptyDownload';

export function NoFile() {
  return <EmptyDownload />;
}
